import { useRecoilValue } from "recoil";

import {
  priceModeAtom,
  profilePermissionsSelector,
  RoleNameEnum,
  SuperAdminPriceMode,
  useHaveCustomPermissions,
  useSystemParams,
} from "@ryde/shared";

export const useRideHeaderPriceVisibility = () => {
  const priceMode = useRecoilValue(priceModeAtom);
  const roleDataItem = useRecoilValue(profilePermissionsSelector);
  const systemParams = useSystemParams();
  const { hasPermissionViewPrices, hasPermissionViewSupplierPrices } =
    useHaveCustomPermissions();
  const isSupplierRole = roleDataItem?.role === RoleNameEnum.Supplier;
  const isPriceModeNotSet =
    priceMode === SuperAdminPriceMode.NotSet || !priceMode;
  const isPriceModeClient = priceMode === SuperAdminPriceMode.Client;
  const isPriceModeSupplier = priceMode === SuperAdminPriceMode.Supplier;
  const isPriceModeBoth = priceMode === SuperAdminPriceMode.Both;
  const isSupplierPriceRatesEnabled =
    systemParams?.enableSupplierPriceRates === true;

  const supplierColumnAllowed =
    isSupplierPriceRatesEnabled && hasPermissionViewSupplierPrices;

  let shouldShowClientPrice: boolean;
  let shouldShowSupplierPrice: boolean;

  if (isPriceModeNotSet) {
    if (!supplierColumnAllowed) {
      shouldShowSupplierPrice = false;
      shouldShowClientPrice = hasPermissionViewPrices;
    } else {
      shouldShowClientPrice = hasPermissionViewPrices;
      shouldShowSupplierPrice =
        supplierColumnAllowed && !hasPermissionViewPrices;
    }
  } else {
    shouldShowSupplierPrice =
      supplierColumnAllowed &&
      (isPriceModeSupplier || isPriceModeBoth || isSupplierRole);
    shouldShowClientPrice =
      (isPriceModeClient || isPriceModeBoth) && hasPermissionViewPrices;
  }

  return {
    shouldShowClientPrice,
    shouldShowSupplierPrice,
  };
};
